import { channelType } from "./transformer";

export const sendBingCode = (payload) => {
    return {
        type: `${channelType}.SEND_CODE`,
        payload: payload
    };
};
